
// material-ui
import React from 'react';
import config from 'config';
import { useNavigate, useParams } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import Accordion from 'ui-component/extended/Accordion';
import { styled, useTheme } from '@mui/material/styles';
import * as localStorageService from 'components/localStorageService';
import { ResolveUrl, ResolvePath, ResolveStorageUrl, GetCachedUrls } from "features/firebase-app";
import * as firebaseapp from 'features/firebase-app';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Pagination, ButtonGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Step, Stepper, StepLabel, FormGroup, FormControlLabel, Switch } from '@mui/material';
import { Badge, Box, Chip, FormControl, InputAdornment, InputLabel, List, ListItemButton, ListItemIcon, ListItemText, MenuItem, OutlinedInput, Select, Tooltip } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { CardActions, FormHelperText } from '@mui/material';
import { } from '@mui/material';

import {
    Card,
    CardContent,
    Divider,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction
} from '@mui/material';
import { Chart } from "react-google-charts";
import * as forms from 'features/forms';
import MainCard from 'ui-component/cards/MainCard';
import { uuid } from 'components/util';
import PerfectScrollbar from 'react-perfect-scrollbar';
import TitleService from 'title-service';
import * as SC from 'features/shared_components';
import { GetTimeSince } from 'title-service';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import RedQuickAlert from 'components/RedQuickAlert';
import rq from 'components/RedQuick';
import SecondaryAction from 'ui-component/cards/CardSecondaryAction';
import ElevationScroll from 'components/ElevationScroll';
import ChatBubbleTwoToneIcon from '@mui/icons-material/ChatBubbleTwoTone';
import RedQuickInputTags from 'components/RedQuickInputTags';
import * as applicationSlice from 'features/application/application-slice';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { AvatarGroup, Avatar, Button, Grid, Stack, TextField, Typography } from '@mui/material';
import SubCard from 'ui-component/cards/SubCard';
import * as models from 'models';
import * as validation from 'validation';
import * as groups from 'groups';
import { useBrowserInfo, useDebounce, useStutter, useInterval, useWatchRealTimeDB, useLocalId, mobileAndTabletCheck } from 'components/utility';
import CancelIcon from '@mui/icons-material/Cancel';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { gridSpacing } from 'store/constant';


// assets
import { useEffect } from 'react';
import * as autoThunks from 'features/auto-thunks';

import { useDispatch, useSelector } from 'react-redux';
import { getUserClaims } from 'features/application/application-slice';
import { ContentCreatorInvitation } from 'models';
import { get_all_contentCreatorInvitation } from 'features/contentCreatorInvitation/contentCreatorInvitation-slice';
import { mergecontentCreatorInvitation } from 'features/contentCreatorInvitation/contentCreatorInvitation-slice';
import { get_selected_contentCreatorInvitation } from 'features/contentCreatorInvitation/contentCreatorInvitation-slice';
import { is_contentCreatorInvitation_busy } from 'features/contentCreatorInvitation/contentCreatorInvitation-slice';
import { setSelectedcontentCreatorInvitation } from 'features/contentCreatorInvitation/contentCreatorInvitation-slice';
import { ContentHouse } from 'models';
import { get_all_contentHouse } from 'features/contentHouse/contentHouse-slice';
import { mergecontentHouse } from 'features/contentHouse/contentHouse-slice';
import { get_selected_contentHouse } from 'features/contentHouse/contentHouse-slice';
import { is_contentHouse_busy } from 'features/contentHouse/contentHouse-slice';
import { setSelectedcontentHouse } from 'features/contentHouse/contentHouse-slice';
import { Views } from 'enumerations';
import * as icons from '@tabler/icons'
// ================================|| UI LIST - SIMPLE LIST ||================================ //

const ListWrapper = styled('div')(({ theme }) => ({
    padding: '15px 0',
    borderBottom: theme.palette.mode === 'dark' ? 'none' : '1px solid',
    borderTop: theme.palette.mode === 'dark' ? 'none' : '1px solid',
    borderColor: `${theme.palette.grey[100]}!important`
}));
const ListItemWrapper = styled('div')(({ theme }) => ({
    cursor: 'pointer',
    padding: 16,
    '&:hover': {
        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
    },
    '& .MuiListItem-root': {
        padding: 0
    }
}));
export default function CustomerAdministratorMenuItem(props: any) {
    // Generate Grid
    let dispatch = useDispatch();
    const navigate = useNavigate();
    let claims = useSelector(getUserClaims);
    const customization = useSelector((state: any) => state.customization);
    useEffect(() => {
        dispatch(autoThunks.init_customer_administrator({
            userId: claims?.user
        }) as any);
    }, [claims?.user]);

    return (
        <>{claims?.customerAdministrator && <List>
            <ListItemButton
                sx={{ borderRadius: `${customization.borderRadius}px` }}
                onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                    navigate(`/${Views.CustomerAdministrator}`)
                }}
            >
                <ListItemIcon>
                    <icons.IconUsers stroke={1.5} size="2.3rem" />
                </ListItemIcon>
                <ListItemText primary={<Typography variant="h3">{TitleService('Administrator')}</Typography>} />
            </ListItemButton>
        </List>}
        </>
    )

}

